import { FC, useEffect } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import ArrowLeftIcon from 'src/components/Icon/ArrowLeftIcon';
import { Title } from 'src/components/Layout/Typography';
import useInsiderTrackingCategory from 'src/hooks/useInsiderTrackingCategory';
import {
	actionGetCategoryDetail,
	actionGetCategoryObatDetail,
} from 'src/redux/actions/categoryByGroup';
import { formatQueryParams } from 'src/utils/func';

import classes from './style.module.css';

const Articles: FC = () => {
	const r = useRouter();
	const dispatch = useDispatch();

	const { detail, detail_obat: detailPenyakit }: any = useSelector(
		(state: RootStateOrAny) => state.categoryByGroup,
	);

	const { category, layout } = r.query;
	const tabQuery = layout ? { layout } : {};

	useInsiderTrackingCategory('articles', detailPenyakit);

	const getDetail = async () => {
		if (category) {
			dispatch(await actionGetCategoryDetail(category as string));
			dispatch(await actionGetCategoryObatDetail(category as string, 'penyakit'));
		}
	};

	useEffect(() => {
		getDetail();
	}, [category]);

	const handleBack = () => {
		r.push({
			pathname: '/penyakit',
			hash: 'keluhan',
			query: tabQuery,
		});
	};

	return (
		<div className="w-full">
			<div className="flex items-center justify-start mb-12">
				<button type="button" onClick={handleBack} className={classes.backBtn} aria-label="Kembali">
					<ArrowLeftIcon />
				</button>
				<Title level={1} text={detail?.name} className="fs-18 mb-0 ml-2" />
			</div>

			<div className={classes.result}>
				<ul className={classes.gridList}>
					{detailPenyakit?.map((item: any, i: number) => (
						<li key={i} className={classes.gridItem}>
							<a href={`/penyakit/${item.url}${formatQueryParams(tabQuery)}`}>
								<Title level={3} text={item.title} className="fs-16 fw-400" />
							</a>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default Articles;
